// texe-web/src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Desteklenen diller (mevcut anahtarlar)
const resources = {
  en: { 
    translation: { 
      // Basic
      welcome: "Welcome", 
      settings: "Settings", 
      profile: "Profile", 
      logout: "Logout", 
      translate: "Translate",
      
      // Rate Limit Messages
      rateLimit: {
        title: "Slow Down",
        generic: "You're doing that too fast. Please wait a moment.",
        auth: "Too many login attempts. Take a short break to protect your account.",
        post: "You've shared a lot today! Rest a bit before posting again.",
        comment: "Whoa, that's a lot of comments! Let's pause for a moment.",
        like: "Too many likes in a short time. Take a breath!",
        savwar: "SavWar voting is temporarily limited. Please try again shortly.",
        tryAgainIn: "Try again in {{seconds}} seconds",
        tryAgainSoon: "Try again in a moment",
      },
      
      // Error Messages
      error: {
        generic: "Something went wrong",
        network: "Network error. Check your connection.",
        unauthorized: "Please log in to continue",
        forbidden: "You don't have permission for this action",
        notFound: "Content not found",
        serverError: "Server error. We're working on it!",
      },
      
      // Success Messages
      success: {
        saved: "Saved successfully",
        updated: "Updated successfully",
        deleted: "Deleted successfully",
        sent: "Sent successfully",
      },
      
      // Badges & Roles
      badge: {
        admin: "Admin",
        moderator: "Moderator",
        vip: "VIP Member",
        boosted: "Boosted Post",
        boost1000: "1000 Likes Boost",
        boost5000: "5000 Likes Boost",
        boost10000: "10K Likes Boost",
        verified: "Verified",
      },
      
      // SavLike & SavWar UI Effects
      effects: {
        likeSuccess: "You liked it! ❤️",
        likeRemoved: "Like removed",
        scoreIncrease: "+{{points}} points earned!",
        starGiven: "⭐ Star given!",
        starReceived: "🌟 Star received! +{{tp}} TP",
        tpGained: "🗡️ +{{tp}} TP gained",
        rankUp: "🎉 Promotion!",
        rankUpMessage: "Congrats! You've been promoted from {{oldRank}} to {{newRank}}!",
        newRecord: "🏆 New Record! {{score}} points",
        topThree: "🌟 You're in the top 3!",
      },
      
      // Outbox Email & Notification (FAZ D)
      email: {
        queued: "Queued",
        sending: "Sending...",
        delivered: "Delivered",
        failed: "Failed",
        retry: "Retry",
      },
      notification: {
        new: "New notification",
        failed: "Delivery failed",
        delivered: "Delivered",
        pending: "Pending",
      },
      admin: {
        outboxTitle: "Outbox Events",
        outboxRetrySuccess: "Event scheduled for retry",
        outboxRetryFailed: "Retry failed",
      },
    } 
  },
  tr: { 
    translation: { 
      // Temel
      welcome: "Hoş geldin", 
      settings: "Ayarlar",  
      profile: "Profil",  
      logout: "Çıkış",  
      translate: "Çevir",
      
      // Rate Limit Mesajları
      rateLimit: {
        title: "Yavaşla",
        generic: "Biraz hızlı davranıyorsun. Lütfen bir an bekle.",
        auth: "Çok fazla giriş denemesi. Hesabını korumak için kısa bir mola ver.",
        post: "Bugün epey paylaştın! Yeni gönderi için biraz dinlen.",
        comment: "Vay canına, ne çok yorum! Bir an ara verelim.",
        like: "Kısa sürede çok fazla beğeni. Bir nefes al!",
        savwar: "SavWar oylaması geçici olarak sınırlı. Birazdan tekrar dene.",
        tryAgainIn: "{{seconds}} saniye sonra tekrar dene",
        tryAgainSoon: "Birazdan tekrar dene",
      },
      
      // Hata Mesajları
      error: {
        generic: "Bir şeyler ters gitti",
        network: "Ağ hatası. Bağlantını kontrol et.",
        unauthorized: "Devam etmek için giriş yap",
        forbidden: "Bu işlem için yetkin yok",
        notFound: "İçerik bulunamadı",
        serverError: "Sunucu hatası. Üzerinde çalışıyoruz!",
      },
      
      // Başarı Mesajları
      success: {
        saved: "Başarıyla kaydedildi",
        updated: "Başarıyla güncellendi",
        deleted: "Başarıyla silindi",
        sent: "Başarıyla gönderildi",
      },
      
      // Rozet & Roller
      badge: {
        admin: "Yönetici",
        moderator: "Moderatör",
        vip: "VIP Üye",
        boosted: "Boost'lu Gönderi",
        boost1000: "1000 Beğeni Boost",
        boost5000: "5000 Beğeni Boost",
        boost10000: "10 Bin Beğeni Boost",
        verified: "Doğrulanmış",
      },
      
      // SavLike & SavWar UI Efektleri
      effects: {
        likeSuccess: "Beğendin! ❤️",
        likeRemoved: "Beğeni geri alındı",
        scoreIncrease: "+{{points}} puan kazandın!",
        starGiven: "⭐ Yıldız verdin!",
        starReceived: "🌟 Yıldız aldın! +{{tp}} TP",
        tpGained: "🗡️ +{{tp}} TP kazandın",
        rankUp: "🎉 Terfiin Var!",
        rankUpMessage: "Tebrikler! {{oldRank}} → {{newRank}} rütbesine yükseldin!",
        newRecord: "🏆 Yeni Rekor! {{score}} puan",
        topThree: "🌟 İlk 3'tesin!",
      },
      
      // Outbox Email & Bildirim (FAZ D)
      email: {
        queued: "Kuyrukta",
        sending: "Gönderiliyor...",
        delivered: "Gönderildi",
        failed: "Başarısız",
        retry: "Tekrar Dene",
      },
      notification: {
        new: "Yeni bildirim",
        failed: "Gönderim başarısız",
        delivered: "İletildi",
        pending: "Beklemede",
      },
      admin: {
        outboxTitle: "Outbox Olayları",
        outboxRetrySuccess: "Olay tekrar denemeleri için planlandı",
        outboxRetryFailed: "Tekrar deneme başarısız",
      },
    } 
  },
  de: { 
    translation: { 
      // Grundlegend
      welcome: "Willkommen", 
      settings: "Einstellungen", 
      profile: "Profil", 
      logout: "Abmelden", 
      translate: "Übersetzen",
      
      // Rate Limit Nachrichten
      rateLimit: {
        title: "Langsamer",
        generic: "Du machst das zu schnell. Bitte warte einen Moment.",
        auth: "Zu viele Anmeldeversuche. Mach eine kurze Pause, um dein Konto zu schützen.",
        post: "Du hast heute viel geteilt! Ruhe dich aus, bevor du wieder postest.",
        comment: "Wow, das sind viele Kommentare! Lass uns einen Moment pausieren.",
        like: "Zu viele Likes in kurzer Zeit. Atme durch!",
        savwar: "SavWar-Abstimmung ist vorübergehend begrenzt. Bitte versuche es in Kürze erneut.",
        tryAgainIn: "Versuche es in {{seconds}} Sekunden erneut",
        tryAgainSoon: "Versuche es gleich noch einmal",
      },
      
      // Fehlermeldungen
      error: {
        generic: "Etwas ist schief gelaufen",
        network: "Netzwerkfehler. Überprüfe deine Verbindung.",
        unauthorized: "Bitte melde dich an, um fortzufahren",
        forbidden: "Du hast keine Berechtigung für diese Aktion",
        notFound: "Inhalt nicht gefunden",
        serverError: "Serverfehler. Wir arbeiten daran!",
      },
      
      // Erfolgsmeldungen
      success: {
        saved: "Erfolgreich gespeichert",
        updated: "Erfolgreich aktualisiert",
        deleted: "Erfolgreich gelöscht",
        sent: "Erfolgreich gesendet",
      },
      
      // Abzeichen & Rollen
      badge: {
        admin: "Administrator",
        moderator: "Moderator",
        vip: "VIP-Mitglied",
        boosted: "Verstärkter Beitrag",
        boost1000: "1000 Likes Boost",
        boost5000: "5000 Likes Boost",
        boost10000: "10.000 Likes Boost",
        verified: "Verifiziert",
      },
      
      // SavLike & SavWar UI-Effekte
      effects: {
        likeSuccess: "Gefällt dir! ❤️",
        likeRemoved: "Like entfernt",
        scoreIncrease: "+{{points}} Punkte gewonnen!",
        starGiven: "⭐ Stern vergeben!",
        starReceived: "🌟 Stern erhalten! +{{tp}} TP",
        tpGained: "🗡️ +{{tp}} TP gewonnen",
        rankUp: "🎉 Beförderung!",
        rankUpMessage: "Glückwunsch! Du wurdest von {{oldRank}} auf {{newRank}} befördert!",
        newRecord: "🏆 Neuer Rekord! {{score}} Punkte",
        topThree: "🌟 Du bist in den Top 3!",
      },
      
      // Outbox Email & Benachrichtigung (FAZ D)
      email: {
        queued: "In Warteschlange",
        sending: "Wird gesendet...",
        delivered: "Geliefert",
        failed: "Fehlgeschlagen",
        retry: "Erneut versuchen",
      },
      notification: {
        new: "Neue Benachrichtigung",
        failed: "Zustellung fehlgeschlagen",
        delivered: "Zugestellt",
        pending: "Ausstehend",
      },
      admin: {
        outboxTitle: "Outbox-Ereignisse",
        outboxRetrySuccess: "Ereignis zur Wiederholung geplant",
        outboxRetryFailed: "Wiederholung fehlgeschlagen",
      },
    } 
  },
} as const;

// Başlangıç dilini seç: localStorage > navigator > tr
const lngFromStorage = (() => { try { return localStorage.getItem("lang") || undefined; } catch { return undefined; } })();
const lngFromNavigator = typeof navigator !== "undefined" ? navigator.language.split("-")[0] : undefined;
const initialLng = (lngFromStorage || lngFromNavigator || "tr").toLowerCase();

// HMR / çift import’ta tekrar init etme
if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: initialLng,
      fallbackLng: "tr",
      interpolation: { escapeValue: false },
      returnEmptyString: false,
    })
    .catch(() => {});
}

export default i18n;
